export const cashRegisters = {
  "cashRegister.settingsSync": "סנכרון הגדרות",
  "cashRegister.settingsCurrent": "ההגדרות הנוכחיות אושרו",
  "cashRegister.settingsPending": "ממתין לאישור ההגדרות הנוכחיות",
  "cashRegister.settingsSent": "שליחת הגדרות אחרונה",
  "cashRegister.settingsAcknowledged": "אישור שמירת הגדרות אחרון",
  "cashRegister.firmware": "קושחה",
  "cashRegister.registrationNumber": "מספר רישום",
  "cashRegister.deviceMode": "מצב מכשיר",
  "cashRegister.cashBalance": "מזומן בקופה",
  "cashRegister.ofdPending": "מסמכים הממתינים ל־OFD",
  "cashRegister.ofdOldest": "המסמך הישן ביותר הממתין ל־OFD",
  "cashRegister.lastDocument": "המסמך האחרון בקופה",
  "cashRegister.lastDocumentAt": "מועד המסמך האחרון בקופה",
  "cashRegister.savedRequest": "בקשה פיסקלית שמורה",
  "cashRegister.savedRequestHint": "זוהי הבקשה השמורה שנשלחה לקופה. המזהים הפיסקליים שלהלן נקראו מהקופה; אין זה עותק מלא של הקבלה המודפסת.",
  "cashRegister.issuerTaxId": "מזהה מס של הארגון",
  "cashRegister.cashier": "קופאי",
  "cashRegister.cashierTaxId": "מזהה מס של הקופאי",
  "cashRegister.unsupportedClinic": "קופות עדיין אינן זמינות למרפאה שלך.",
  "cashRegister.alreadyFiscalized": "כבר קיים מסמך פיסקלי עבור הפעולה הכספית הזו. יש לבדוק ביומן הקופה.",
  "cashRegister.sourceMismatch": "התשלום או ההחזר שייכים לסניף, למנפיק או למטבע אחר. יש לבחור קופה מתאימה.",
  "cashRegister.pairingThrottled": "קוד הונפק לפני פחות מדקה. יש להמתין דקה לפני בקשת קוד נוסף.",
  "cashRegister.transferRequired": "הקופה כבר מחוברת. יש להעביר אותה בכרטיס הקופה לפני חיבור עמדת עבודה אחרת.",
  "cashRegister.unresolved": "פעולה או הדפסה טרם הושלמו. יש לטפל בהן ביומן וברכיב שבמגש המערכת.",
  "cashRegister.evidenceConflict": "פרטי המסמך סותרים את הפעולה או מסמך אחר שנשמר. יש לבדוק את הראיות הפיסקליות המקוריות.",
  "cashRegister.noEffect": "היעדר מסמך אינו מוכיח שלא התרחשה פעולה פיסקלית. נדרשות ראיות מהציוד לקביעת התוצאה.",
  "cashRegister.alreadyResolved": "פעולה זו אינה דורשת עוד התאמה. יש לרענן את הרשומה ביומן.",
  "cashRegister.deviceAssigned": "הציוד הזה כבר משויך. יש להעביר את הקופה הנוכחית לפני חיבורו כאן.",
  "cashRegister.notReady": "הציוד אינו מוכן. יש לבדוק את מנהל ההתקן, החיבור והמצב הפיסקלי.",
  "cashRegister.shiftRequired": "לפעולה נדרשת משמרת פתוחה שטרם פגה.",
  "cashRegister.codeInvalid": "קוד החיבור שגוי, פג תוקף או כבר נוצל. יש לבקש קוד חדש בכרטיס הקופה.",
  "cashRegister.versionUnsupported": "פרוטוקול הרכיב המקומי אינו תואם. יש להתקין את גרסת הרכיב שפורסמה.",
  "cashRegister.pending": "שליחה…",
  "cashRegister.createHolding": "יש להזין שם קופה ולבחור סניף.",
  "cashRegister.vat.none": "ללא מע״מ",
  "cashRegister.vat.vat0": "0%",
  "cashRegister.vat.vat5": "5%",
  "cashRegister.vat.vat7": "7%",
  "cashRegister.vat.vat10": "10%",
  "cashRegister.vat.vat20": "20%",
  "cashRegister.vat.vat22": "22%",
  "cashRegister.vat.vat105": "5/105",
  "cashRegister.vat.vat107": "7/107",
  "cashRegister.vat.vat110": "10/110",
  "cashRegister.vat.vat120": "20/120",
  "cashRegister.vat.vat122": "22/122",
  "cashRegister.server": "כתובת HTTPS של המערכת",
  "cashRegister.title": "קופות",
  "cashRegister.description": "ציוד, חיבורי עמדות, משמרות ומסמכי מס",
  "cashRegister.deviceError": "שגיאת ציוד",
  "cashRegister.noDeviceError": "לא דווחה שגיאה",
  "cashRegister.model": "דגם הקופה",
  "cashRegister.name": "שם הקופה",
  "cashRegister.itemName": "שם הפריט",
  "cashRegister.branch": "סניף",
  "cashRegister.taxSystem": "שיטת מיסוי",
  "cashRegister.create": "יצירת קופה",
  "cashRegister.save": "שמירה",
  "cashRegister.cancel": "ביטול",
  "cashRegister.loading": "טוען קופות…",
  "cashRegister.empty": "אין עדיין קופות",
  "cashRegister.failed": "לא ניתן להשלים את הפעולה בקופה. יש לרענן את המצב ולבדוק את החיבור ואת ראיות הפעולה.",
  "cashRegister.forbidden": "אין לך הרשאה לפעולה זו.",
  "cashRegister.conflict": "הקופה דחתה את הפעולה. יש לבדוק את המצב ואת היומן.",
  "cashRegister.itemsUnsupported": "הראיות הכספיות השמורות אינן מתארות מסמך מס נתמך. יש לבדוק סעיפי שירות, הקצאת תשלום, מס מפורש וקבלה מקורית להחזר.",
  "cashRegister.unsaved": "יש שינויים שלא נשמרו בהגדרות הקופה.",
  "cashRegister.state": "מצב",
  "cashRegister.shift": "משמרת",
  "cashRegister.connection": "חיבור",
  "cashRegister.install": "דיסק התקנה",
  "cashRegister.openShift": "פתיחת משמרת",
  "cashRegister.closeShift": "סגירת משמרת",
  "cashRegister.journal": "יומן פעולות",
  "cashRegister.kind": "פעולה",
  "cashRegister.amount": "סכום",
  "cashRegister.created": "תאריך רישום",
  "cashRegister.print": "הדפסה",
  "cashRegister.document": "מסמך מס",
  "cashRegister.refresh": "רענון",
  "cashRegister.more": "טעינת רשומות נוספות",
  "cashRegister.noBinding": "לא משויכת",
  "cashRegister.stale": "התצפית אינה עדכנית",
  "cashRegister.agent": "רכיב מקומי",
  "cashRegister.driver": "מנהל התקן",
  "cashRegister.device": "ציוד",
  "cashRegister.fiscal": "מוכנות מס",
  "cashRegister.paper": "נייר",
  "cashRegister.ofd": "תקשורת עם מפעיל נתוני המס",
  "cashRegister.observed": "בדיקה אחרונה",
  "cashRegister.machine": "עמדה",
  "cashRegister.serial": "מספר סידורי של הקופה",
  "cashRegister.storage": "מספר סידורי של הזיכרון הפיסקלי",
  "cashRegister.reason": "סיבה",
  "cashRegister.rename": "שינוי שם",
  "cashRegister.transfer": "העברה לעמדה אחרת",
  "cashRegister.archive": "העברת קופה לארכיון",
  "cashRegister.drainHint": "פעולות עם תוצאה לא ידועה והדפסה שלא הושלמה חוסמות העברה. יש להשלים בירור ואז לחזור על ההעברה.",
  "cashRegister.installSteps": "יש להתקין את רכיב Windows, לפתוח אותו ממגש המערכת ולהדביק את קוד החיבור מדף זה. את הציוד יש להגדיר בכלי בדיקת הדרייבר של היצרן. לאחר החיבור יוצגו כאן דיווחי הרכיב.",
  "cashRegister.install.getComponent": "הורדת הרכיב",
  "cashRegister.install.runInstaller": "התקנה בעמדת העבודה",
  "cashRegister.install.connect": "חיבור עמדת העבודה למערכת",
  "cashRegister.install.verify": "בדיקת הציוד",
  "cashRegister.install.version": "גרסת הרכיב",
  "cashRegister.install.size": "גודל המתקין",
  "cashRegister.install.checksum": "SHA-256 של המתקין",
  "cashRegister.install.distributionFailed": "לא ניתן לקרוא את הרכיב שפורסם. יש לחזור על הבקשה; אין בכך השפעה על הקופה עצמה.",
  "cashRegister.country": "פרופיל מדינה",
  "cashRegister.countryLimited": "ציוד הקופה תומך כעת בכללים הפיסקליים של רוסיה RU/RUB.",
  "cashRegister.unsigned": "המתקין ללא חתימה דיגיטלית. Windows עשוי להזהיר על המפרסם או לחסום הפעלה בהתאם למדיניות המחשב. HTTPS ומניפסט SHA-256 מגנים על שלמות ההורדה.",
  "cashRegister.download": "הורדת מתקין Windows",
  "cashRegister.manifest": "הורדת מניפסט SHA-256",
  "cashRegister.vendor.atol": "אטול DTO 10",
  "cashRegister.vendor.shtrih": "שטריך",
  "cashRegister.vendor": "התקנת מנהל התקן x86 של הספק בנפרד",
  "cashRegister.pair": "יצירת קוד חיבור",
  "cashRegister.code": "קוד חיבור",
  "cashRegister.expires": "בתוקף עד",
  "cashRegister.codeHint": "יש להעתיק את קוד החיבור במלואו לרכיב המקומי. הקוד כולל את כתובת השרת, תקף לשימוש אחד ופג לאחר עשר דקות.",
  "cashRegister.preview": "בדיקת מסמך מס",
  "cashRegister.queue": "שליחה לקופה",
  "cashRegister.receiptAction": "הפקת קבלה פיסקלית",
  "cashRegister.refundAction": "הפקת החזר פיסקלי",
  "cashRegister.sourceHint": "פעולה זו מפיקה מסמך מס עבור הפעולה הכספית השמורה. היא אינה רושמת תשלום או החזר נוסף.",
  "cashRegister.queued": "הפעולה נשמרה. יש לבדוק את התוצאה הסופית ביומן הקופה.",
  "cashRegister.events": "אירועי פעולה",
  "cashRegister.evidence": "הפניה לראיה",
  "cashRegister.reconcile": "בירור לפי מסמך מס",
  "cashRegister.reconcileHint": "יש להזין מזהי מסמך שהופק בפועל בקופה. היעדר מסמך לבדו אינו מתיר הפעלה נוספת. המשך הדפסה נעשה ברכיב המגש עבור מסמך קיים זה בלבד.",
  "cashRegister.number": "מספר מסמך",
  "cashRegister.fiscalSign": "חתימה פיסקלית",
  "cashRegister.issuedAt": "זמן המסמך בקופה (ISO 8601 עם היסט אזור זמן)",
  "cashRegister.shiftNumber": "מספר משמרת",
  "cashRegister.back": "חזרה לקופה",
  "cashRegister.quantity": "כמות",
  "cashRegister.vat": "מע״מ",
  "cashRegister.signal.ready": "מוכן",
  "cashRegister.signal.unknown": "לא ידוע",
  "cashRegister.signal.unavailable": "לא זמין",
  "cashRegister.signal.unsupported": "לא נתמך",
  "cashRegister.shift.open": "פתוחה",
  "cashRegister.shift.closed": "סגורה",
  "cashRegister.shift.expired": "פג תוקפה",
  "cashRegister.shift.unknown": "לא ידוע",
  "cashRegister.lifecycle.active": "פעילה",
  "cashRegister.lifecycle.draining": "השלמת פעולות שהתקבלו",
  "cashRegister.lifecycle.archived": "בארכיון",
  "cashRegister.kind.open_shift": "פתיחת משמרת",
  "cashRegister.kind.close_shift": "סגירת משמרת",
  "cashRegister.kind.sale": "קבלת מכירה",
  "cashRegister.kind.refund": "קבלת החזר",
  "cashRegister.kind.recover": "שחזור",
  "cashRegister.state.queued": "בתור",
  "cashRegister.state.prepared": "מוכנה",
  "cashRegister.state.executing": "ההפעלה אושרה",
  "cashRegister.state.succeeded": "תוצאת המס אושרה",
  "cashRegister.state.failed": "נכשלה לפני פעולת המס",
  "cashRegister.state.outcome_unknown": "תוצאה לא ידועה — יש לברר לפני ניסיון נוסף",
  "cashRegister.state.cancelled": "בוטלה לפני אישור הפעלה",
  "cashRegister.print.unknown": "לא ידוע",
  "cashRegister.print.not_required": "לא נדרשת",
  "cashRegister.print.printed": "הודפס",
  "cashRegister.print.pending": "מסמך המס נרשם; ההדפסה לא הושלמה",
  "cashRegister.taxSystem.osn": "מיסוי כללי",
  "cashRegister.taxSystem.usn_income": "מיסוי פשוט: הכנסות",
  "cashRegister.taxSystem.usn_income_outcome": "מיסוי פשוט: הכנסות פחות הוצאות",
  "cashRegister.taxSystem.esn": "מס חקלאי",
  "cashRegister.taxSystem.patent": "פטנט",
} as const
